/* eslint-disable react/prop-types */
import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { getTrackFromEpisode } from "../../utils";
import { AddToQueue, DownloadIcon, PauseButton, PlayButton, PresentInQueueIcon, ArrowUp, ArrowDown } from "./icons";
import { Loader } from "./Loader";
import { PlayerContext } from "./player-context";
import get from "lodash/get";

import "./show-list.m.css";
import { SubscriberOnlyEpisode } from "./subscriber-only-episode";

export function EpisodeItem({ episode, podcast, podcastTitle, inQueueComponent }) {
  const playerContext = useContext(PlayerContext);
  const addTrackToQueueAndPlayTrack = data => {
    playerContext.playTrack(data);
  };

  const handlePlay = episode => {
    const track = getTrackFromEpisode(episode, podcast);

    if (playerContext.currentTrackId === track._id) {
      playerContext.play();
    } else {
      addTrackToQueueAndPlayTrack(track);
      playerContext.setCurrentScreen(null);
    }
  };

  const handlePause = () => {
    playerContext.pause();
  };
  const isTrackPlaying = trackId => playerContext.audioStatus === "playing" && playerContext.currentTrackId === trackId;
  const isTrackLoading = trackId => playerContext.audioStatus === "loading" && playerContext.currentTrackId === trackId;
  const isTrackLoaded = trackId => playerContext.currentTrackId === trackId;

  const isSubscriberOnly = episode.status === "draft";

  const hasSubscription = useSelector(state => {
    return get(state, ["isSubscribedUser", "userHasSubscription"], false);
  });

  const showLockIcon = !hasSubscription && isSubscriberOnly;

  const renderPlayButton = episode => {
    if (isTrackPlaying(episode._id)) {
      return (
        <button
          aria-label="Pause"
          title="Pause"
          styleName="icon-btn play-btn"
          className="pressable"
          onClick={handlePause}
        >
          Pause <PauseButton width={20} fill={"#e3e2e2"} />
        </button>
      );
    } else if (isTrackLoading(episode._id)) {
      return (
        <button
          aria-label="loading"
          aria-disabled={true}
          title="Loading"
          styleName="icon-btn play-btn"
          className="pressable"
        >
          <Loader />
        </button>
      );
    } else {
      return (
        <button
          aria-label={"Play " + episode.title}
          title="Play"
          styleName="icon-btn play-btn"
          className="pressable"
          onClick={() => handlePlay(episode)}
        >
          Play <PlayButton width={18} fill={"#e3e2e2"} />
        </button>
      );
    }
  };

  if (showLockIcon) {
    return <SubscriberOnlyEpisode episode={episode} />;
  }

  return (
    <article>
      <section>
        <div styleName="show_list_meta">
          <div styleName="show_list_meta_text">
            <div>{episode.title}</div>
            {podcastTitle && <div styleName="show_list_meta_text--podcast-title">{podcastTitle}</div>}
            <div styleName="action-button-wrapper">
              {renderPlayButton(episode)}

              {playerContext.isTrackPresentInQueue(episode._id) ? (
                <button
                  disabled={isTrackLoaded(episode._id)}
                  className="pressable icon-btn"
                  styleName="icon-btn"
                  title="Queued"
                  onClick={() => playerContext.removeTrackFromQueue(episode._id)}
                >
                  <PresentInQueueIcon width={28} fill={"#f26367"} />
                </button>
              ) : (
                <button
                  aria-label="Add to Queue"
                  className="pressable"
                  styleName="icon-btn"
                  title="Add to Queue"
                  onClick={() => playerContext.addTrackToQueue(getTrackFromEpisode(episode, podcast))}
                >
                  <AddToQueue width={28} fill={"#e3e2e2"} />
                </button>
              )}
              {inQueueComponent ? (
                <button
                  aria-label="Move Up"
                  className="pressable"
                  styleName="icon-btn"
                  title="Move Up"
                  onClick={() => playerContext.moveUpQueue(episode)}
                >
                  <ArrowUp width={28} fill={"#e3e2e2"} />
                </button>
              ) : null}
              {inQueueComponent ? (
                <button
                  aria-label="Move down"
                  className="pressable"
                  styleName="icon-btn"
                  title="Move Down"
                  onClick={() => playerContext.moveDownQueue(episode)}
                >
                  <ArrowDown width={28} fill={"#e3e2e2"} />
                </button>
              ) : null}
            </div>
          </div>
        </div>
      </section>
    </article>
  );
}
